import { useMutation } from '@apollo/client';
import axios from 'axios';
import { graphql, type VariablesOf } from 'graphql-schema';
import { useState } from 'react';

const SIGNED_UPLOAD_URL = graphql(`
  mutation get($kind: S3UploadFolder!, $filename: String!) {
    getSignedUploadUrl(kind: $kind, filename: $filename) {
      accessUrl
      uploadUrl
    }
  }
`);

type Vars = VariablesOf<typeof SIGNED_UPLOAD_URL>;

type UploadParams = Pick<Vars, 'kind'> & {
  file: File;
  filename?: string;
};

const useUploadFileToS3 = () => {
  const [loading, setLoading] = useState(false);

  const [getSignedUploadUrl] = useMutation(SIGNED_UPLOAD_URL);

  const upload = async (params: UploadParams) => {
    const { file, kind, filename: filenameProp } = params;

    const filename = filenameProp ?? file.name;

    setLoading(true);

    try {
      const { data } = await getSignedUploadUrl({
        variables: {
          kind,
          filename,
        },
      });

      if (!data?.getSignedUploadUrl) {
        throw new Error('Failed to upload venue image. Please try again.');
      }

      const { accessUrl, uploadUrl } = data.getSignedUploadUrl;

      await axios.put(uploadUrl, file, {
        headers: {
          'Content-Type': file.type ?? 'multipart/form-data',
        },
      });

      return { filename, url: accessUrl };
    } finally {
      setLoading(false);
    }
  };

  return {
    upload,
    loading,
  };
};

export default useUploadFileToS3;
